module.exports = __webpack_public_path__ + "img/gb-sct.bd1aaeec.svg";